<template>
  <div>
    <div class="search-list"
         v-for="(list,index) in bigList"
         :key="index">
      <span class="search-label">{{list.name}}：</span>
      <div class="search-con">
        <template v-if="list.form == 'disease_id'">
          <a :class="{'search-active' : selectedResult[list.name] == 0}"
             @click="tabHospitalIndex(list,0,list.name,list.select,list.form)">不限</a>
          <a :class="{'search-active' : selectedResult[list.name].includes(serve.id)}"
             v-for="(serve,idx) in list[0][0]"
             @click="tabHospitalIndex(list,serve.id,list.name,list.select,list.form)">{{serve.name}}</a>
        </template>
        <template v-else>
          <a :class="{'search-active' : selectedResult[list.form] == 0}"
             @click="tabHospitalIndex(list,0,list.name,list.select,list.form)">不限</a>
          <a :class="{'search-active' : selectedResult[list.form] == serve.id}"
             v-for="(serve,idx) in list[0][0]"
             @click="tabHospitalIndex(list,serve.id,list.name,list.select,list.form)">{{serve.name}}</a>
        </template>
      </div>
    </div>
    <!--<div class="search-input">
      <label for="keyword">关键字：</label>
      <input type="text"
             v-model="keyword">
      <button class="search-btn"
              @click="searching">搜索</button>
    </div>-->
  </div>
</template>
<script>
import * as apis from "@/api/other"
import * as hos from '@/api/hospital'
export default {
  data () {
    return {
      bigList: [],
      keyword: '',
      serviceType: '',   //服务类型
      slideText: '展开',
      slideFlag: 1,
      slideClass: 'ivu-icon-ios-arrow-up',

      selectedResult: {

      },
      params: {}
    }
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    country: {
      type: Number,
      default: 0
    }
  },
  watch: {
    type: function (newVal) {

      // this.selectedResult.disease_id.push(newVal);
    },
    country: function (newVal) {
      // 高亮显示选中的国家与头部筛选一致
      this.selectedResult.state_id = newVal
      this.params.state_id = newVal
      this.$forceUpdate();
      this.$emit("searchResult", this.params);
    },
    $route: {
      handler: function (val, oldVal) {
        let name = this.$route.params.type;
        // console.log(name)
        this.getHospitalIndex(name)

      },
      deep: true
    }
  },
  components: {
    // Slide,
    // Radio
  },
  mounted () {
    this.serviceType = this.$route.params.type;

    // console.log(this.serviceType,'------')
    this.getHospitalIndex(this.serviceType);
  },
  methods: {
    searching () {
      this.params.keyword = this.keyword;
      this.$emit("searchResult", this.params);
    },
    // tabHospitalIndex (list, val, name, select, form_id) {
    //   //form_id  字段名
    //   console.log(name)
    //   if (form_id == 'state_id') {    //单选
    //     this.selectedResult[form_id] = val;
    //     this.params[form_id] = val;
    //     this.$forceUpdate();
    //   } else {
    //     if (this.selectedResult[form_id].includes(val)) {
    //       let index = this.selectedResult[form_id].indexOf(val);
    //       this.selectedResult[form_id].splice(index, 1)
    //       this.$forceUpdate();
    //     } else {
    //       this.selectedResult[form_id].push(val)
    //       this.$forceUpdate();
    //     }
    //     this.params[form_id] = this.selectedResult[form_id];
    //   }
    //   this.$forceUpdate();
    //   this.$emit("searchResult", this.params);
    // },
    tabHospitalIndex (list, val, name, select, form_id) {
      //form_id  字段名
      console.log(form_id)
      console.log(val)
      if (form_id == 'state_id') {    //单选
        this.selectedResult[form_id] = val;
        this.params[form_id] = val;
        this.$forceUpdate();
      } else if (form_id == 'disease_id' && (val === 53 || val === 52 || val === 54)) {
        console.log(val)
        if (val === 53) { // 体检
          this.$router.push({
            path: '/hospitalList/jmtj/1'
          })
          return
        }
        if (val === 52) { // 远程咨询
          this.$router.push({
            path: '/hospitalList/yczx/0'
          })
          return
        }
        if (val === 54) { // 先进医疗
          this.$router.push({
            path: '/hospitalList/xjyl/0'
          })
          return
        }
      } else {
        if (!this.selectedResult[name].length) {
          if (this.selectedResult[name].includes(val)) {
            let index = this.selectedResult[name].indexOf(val);
            this.selectedResult[name].splice(index, 1)
            this.$forceUpdate();
          } else {
            this.selectedResult[name][0] = val
            this.$forceUpdate();
          }
        } else {
          this.selectedResult[name][0] = val
        }
        let arr = []
        for (let key in this.selectedResult) {
          if (this.selectedResult[key].length && this.selectedResult[key][0]) {
            arr.push(this.selectedResult[key][0])
          }
        }
        this.params[form_id] = arr;
      }
      this.$forceUpdate();
      this.$emit("searchResult", this.params);
    },
    async getHospitalIndex (name) {
      try {
        let data = {
          name
        };
        let res = await hos.getHospitalIndex(data);
        if (res.code == 200) {
          this.bigList = res.data;
          res.data.forEach(item => {
            if (item.select == 1) {
              if (!this.selectedResult[item.form]) {
                this.selectedResult[item.name] = []; // 重置选项为不限
                this.params[item.form] = []
                let val = Number(this.$route.params.hospitalType) ? Number(this.$route.params.hospitalType) : 0
                this.selectedResult.state_id = val; // 国家如已选择，设为默认值
                this.params.state_id = val
                this.$emit("searchResult", this.params);
              }
            } else {
              this.selectedResult[item.form] = [];
            }
          })
        }
      } catch (e) {
        console.log(e)
      }
    },
    sendParams () {
      this.$emit("showSideMenu", flag)
    },
    slideUpAndDown () {
      if (this.slideFlag == 1) {
        this.slideClass = 'ivu-icon-ios-arrow-down';
        this.slideText = '收起';
        this.slideFlag = 2;
      } else {
        this.slideClass = 'ivu-icon-ios-arrow-up';
        this.slideText = '展开';
        this.slideFlag = 1;
      }
    },
  }
}
</script>
<style lang="less" scoped>
.search-input {
  margin-bottom: 15px;
}
.search-selects {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  .ivu-select {
    width: 280px;
  }
  .ivu-icon-ios-arrow-down:before {
    content: '\F33D';
  }
  .ivu-select-large.ivu-select-single .ivu-select-selection {
    height: 45px;
  }
  .ivu-select-single {
    .ivu-select-selection {
      .ivu-select-selected-value {
        padding-left: 20px;
      }
    }
  }
}
.search-list {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  .search-label {
    display: inline-block;
    width: 80px;
    font-size: 14px;
    color: #333130;
    line-height: 24px;
  }

  .search-con {
    flex: 1;
    transition: all linear 0.5s;
    overflow: hidden;
    a {
      display: inline-block;
      height: 24px;
      color: #333130;
      font-size: 14px;
      line-height: 24px;
      border-radius: 4px;
      padding: 0 10px;
      margin-right: 10px;
      margin-bottom: 28px;
    }
    a.search-active {
      background: #ae1e10;
      color: #fff;
    }
  }
  .con1 {
    height: 52px;
    transition: height linear 0.5s;
  }
  .con2 {
    height: auto;
    transition: height linear 0.5s;
  }
}
.search-second {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  a.search-active {
    background: #ae1e10;
    color: #fff;
  }
  .search-sub-label {
    display: inline-block;
    min-width: 120px;
    height: 24px;
    color: #333130;
    font-size: 14px;
    padding: 0 10px;
    margin-right: 10px;
    box-sizing: border-box;
    border-right: 2px solid #8c8c8c;
  }
}
.search-slide {
  width: 80px;
  color: #ae1e10;
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
  padding: 0 10px;
}
.search-input {
  label {
    display: inline-block;
    width: 80px;
    color: #333130;
    font-size: 14px;
    line-height: 24px;
  }
  input {
    height: 24px;
    font-size: 14px;
  }
}
.search-btn {
  width: 80px;
  background: #ae1e10;
  color: #fff;
  font-size: 14px;
  line-height: 24px;
  border: none;
}
</style>

